module.exports = __webpack_public_path__ + "static/img/yarpen.b566966.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/yarpen.png
// module id = 1Xqg
// module chunks = 0